<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Reprint Voucher</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Reprint Prepaid Voucher</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
        <form>
          <br>
        <b-row>
          <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
          </b-col>
          <b-col col cols="8" sm="8" md="8" lg="4">
              <b-form-input type="text" maxlength="12" id="consNo" value=""  placeholder="Enter your Consumer Number" trim required />
          </b-col>
          <b-col col cols="4" sm="3" md="3" lg="1">
                <b-button @click="sendOtp()" block pill variant="primary" size="md" class="go" style="width:100%">
                  <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                </b-button>

          </b-col>
        </b-row>
      </form>
    </br>

    <div id="MobileUpdateDiv" style="display:none">
         <b-row>
           <b-col cols=12>
                <h4 style="color:red">Unable to send OTP. Mobile Number Not Updated</h4>
               <a href="MobileUpdate" >Click Here to Update Your Mobile Number</a>
           </b-col>
         </b-row>
       </div>
    <div id="VoucherDiv" class="hideDetails">
            <!-- <b-card header-bg-variant="light" header-text-variant="white" header="Payment Receipt" class="cardStyle">
           -->
           <b-row>
             <b-col cols=12>
                 <span class="heading">Voucher Details</span>
             </b-col>
           </b-row>

              <b-row>
                <b-col col cols='12' sm="12" md="12" lg="12">
                  <b-table  responsive  :items="voucherList" :fields="voucherListFields">
                    <template   v-slot:cell(link)="data">
                      <span  v-html="data.value"></span>
                   </template>
                  </b-table>
                  </b-col>

              </b-row>
            <!-- </b-card> -->
      </div>
      <br>

</div>

  </b-container>

</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay
      :show="show1"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style=""
      variant="dark"
      id="loader"
    >
      Enter the OTP received in your mobile number {{consMobile}}
      <b-form-input type="number" id="otp" ></b-form-input><br>
      <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()" >Verify</b-button> &nbsp&nbsp
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
    </b-modal>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var mobileNo = "";
var consNo = "";
export default {
  name: '',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
      show1:false,
      consMobile:"",
      voucherList : [],
      voucherListFields: [
        { key: 'txnId', label: 'Transaction Id',thStyle: {width: '15vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'voucherAmt', label: 'Voucher Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'PaymentDate', label: 'Payment Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'link', label: 'Download Voucher',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ]
    }
  },
  methods: {
    showDetails() {

    var consNo = document.getElementById("consNo").value;
    this.consumerNo = consNo;
    // if (consNo.toString().length!=12)
    //     {
    //       this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
    //         title: `Alert`,
    //         variant: 'danger',
    //         solid: true
    //       })
    //     }
    //     else

        {
          this.show= true;
          var parent = this;
          axios.post(this.$urlCommon+'/api/web/voucherReprint?consNo='+consNo)
          .then((response) => {
            parent.show= false;
            console.log(response.data);
            document.getElementById("VoucherDiv").classList.add("showDetails");
            var temp = [];
              response.data.forEach(element => {
                    var res1= element.paymentDt.split("-");
                    var paymentDt = res1[2]+"/"+res1[1]+"/"+res1[0];
                    var obj = {
                    "txnId":element.transactionId,
                    "voucherAmt":element.voucherAmount,
                    "PaymentDate":element.paymentDt,
                    "link": "<a style='padding-left:40%' target='_blank' href='"+element.downloadLink+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
                }
                temp.push(obj)

            })
            console.log(temp)
            this.voucherList = temp
          })
          .catch((e) => {
            parent.show= false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="Sorry, Consumer / Voucher not found";
          console.log("Caught :::::::::::::::", e.message);

        })

        }
      },


    closeModal(){
      this.$bvModal.hide('model')
    },
    sendOtp()
    {
     var parent =this;
     parent.show= true;
     consNo = document.getElementById("consNo").value;
     if ((consNo.toString().length!=12))
         {
           this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
             title: `Alert`,
             variant: 'danger',
             solid: true
           })
           return
         }
      axios.post(parent.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
         .then((response) => {
         parent.show= false;
         console.log(response.data);
         var data=response.data;
         var status = data.message;

         if(status=="00")
         {
           mobileNo = data.mobile_no;


           if (mobileNo == null || mobileNo.length != 10)
           {
             parent.show= false;
             document.getElementById("MobileUpdateDiv").style.display="block";
             document.getElementById("BillDiv").classList.remove("showDetails");

           }
           else {
             let newStr = mobileNo.substring(0,2) + "*****" + mobileNo.substring(7);
             console.log(newStr);
             parent.consMobile = newStr;
             document.getElementById("MobileUpdateDiv").style.display="none";
             var parent2=parent;
             axios.post(parent.$urlCommon+"/api/generateOtp?mobNo="+mobileNo).then(function(response) {
             console.log(response.data);
             parent2.show= false;
             if (response.data.message == "success") {
               parent2.$bvToast.toast('OTP Sent Successfully !', {
                 title: `Success`,
                 variant: 'success',
                 solid: true
               });
               parent2.$bvModal.show('otpModal');

             }
           });
         }
         }
         else
         {
           parent.$bvModal.show('model');
           document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";

         }

       })
       .catch((e) => {
       console.log("Caught", e);
       this.show= false;
     })


    },


    resendOtp()
    {
      var parent =this;

      parent.show1= true;
      axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobileNo).then(function(response) {
        parent.show1= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

  verifyOtp()
    {
      var parent =this;

      var otp = document.getElementById("otp").value;

      parent.show1= true;
      axios.post(parent.$urlCommon+"/api/VerifyOtpVoucher?consNo="+consNo+"&otp="+otp+"&mobNo="+mobileNo).then(function(response) {
        parent.show1= false;
        console.log(response.data);

        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Verified Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.hide('otpModal');
          document.getElementById("VoucherDiv").classList.add("showDetails");
          var temp = [];
            response.data.voucherData.body.forEach(element => {
                  var res1= element.paymentDt.split("-");
                  var paymentDt = res1[2]+"/"+res1[1]+"/"+res1[0];
                  var obj = {
                  "txnId":element.transactionId,
                  "voucherAmt":element.voucherAmount,
                  "PaymentDate":element.paymentDt,
                  "link": "<a style='padding-left:40%' target='_blank' href='"+element.downloadLink+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
              }
              temp.push(obj)

          })
          console.log(temp)
          parent.voucherList = temp
        }
      else {
          parent.$bvToast.toast('OTP not Valid !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
          parent.show1= false;
        }
    });
    },


  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2){
  .paddingLeft30px{
    padding-left: 0px;
  }
  .hideDetails
  {
    box-shadow: none;
    padding: 0px;
  }
}
</style>
